import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
var Icon = function(props) {
    return props.isDark ? /*#__PURE__*/ _jsxs("svg", {
        viewBox: "0 0 24 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M23.34 11.957H15.0222C14.6587 11.957 14.3623 12.2533 14.3623 12.6168C14.3623 12.8019 14.441 12.9687 14.5637 13.089L20.4208 18.946C20.541 19.0756 20.7149 19.1568 20.9047 19.1568C21.1338 19.1568 21.3352 19.0411 21.4533 18.8651C22.8933 17.1936 23.8193 15.0707 23.9861 12.7348C23.9953 12.6955 23.9999 12.6562 23.9999 12.6167C23.9999 12.2533 23.7059 11.957 23.34 11.957Z",
                fill: "#505A73"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.51 0C12.1465 0.00221454 11.8525 0.296323 11.8525 0.659769V9.90369C11.8525 10.2696 12.1465 10.5659 12.51 10.5659H21.7563C22.1199 10.5659 22.4161 10.2696 22.4161 9.90369C22.0896 4.58387 17.8322 0.326476 12.51 0Z",
                fill: "#505A73"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.5921 18.4072L10.772 11.5871C10.6562 11.469 10.5868 11.3046 10.5868 11.1264L10.5844 1.49341C10.5844 1.12996 10.2904 0.835938 9.92695 0.835938C4.38704 1.17397 0 5.77621 0 11.3996C0 17.245 4.739 21.9863 10.5844 21.9863C13.2514 21.9863 15.6867 21.0002 17.548 19.3725C17.6916 19.2521 17.7819 19.0717 17.7819 18.8702C17.7819 18.6919 17.7101 18.5275 17.5921 18.4072Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ _jsxs("svg", {
        viewBox: "0 0 24 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M23.34 11.957H15.0222C14.6587 11.957 14.3623 12.2533 14.3623 12.6168C14.3623 12.8019 14.441 12.9687 14.5637 13.089L20.4208 18.946C20.541 19.0756 20.7149 19.1568 20.9047 19.1568C21.1338 19.1568 21.3352 19.0411 21.4533 18.8651C22.8933 17.1936 23.8193 15.0707 23.9861 12.7348C23.9953 12.6955 23.9999 12.6562 23.9999 12.6167C23.9999 12.2533 23.7059 11.957 23.34 11.957Z",
                fill: "#D0DAE7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.51 0C12.1465 0.00221454 11.8525 0.296323 11.8525 0.659769V9.90369C11.8525 10.2696 12.1465 10.5659 12.51 10.5659H21.7563C22.1199 10.5659 22.4161 10.2696 22.4161 9.90369C22.0896 4.58387 17.8322 0.326476 12.51 0Z",
                fill: "#D0DAE7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.5921 18.4072L10.772 11.5871C10.6562 11.469 10.5868 11.3046 10.5868 11.1264L10.5844 1.49341C10.5844 1.12996 10.2904 0.835938 9.92695 0.835938C4.38704 1.17397 0 5.77621 0 11.3996C0 17.245 4.739 21.9863 10.5844 21.9863C13.2514 21.9863 15.6867 21.0002 17.548 19.3725C17.6916 19.2521 17.7819 19.0717 17.7819 18.8702C17.7819 18.6919 17.7101 18.5275 17.5921 18.4072Z",
                fill: "#194BFB"
            })
        ]
    });
};
export default Icon;
